import RegisterZipCodeError from './RegisterZipCodeError';
class ZipCodeHasInvalidFormat extends RegisterZipCodeError {
    constructor(options) {
        super('Zip code has invalid format', options);
    }
}
export default ZipCodeHasInvalidFormat;
